export const InvoiceTypes = {
  SEGMENT: 'SEGMENT',
  ORGANIZATION: 'ORGANIZATION',
  USER: 'USER',
} as const;

export type InvoiceType = typeof InvoiceTypes[keyof typeof InvoiceTypes];
